<div class="row" data-cy="io-toolbar-container">
  <!-- Actions -->
  <div class="col-4 pt-2" data-cy="io-toolbar-actions">
    <button mat-mini-fab class="bg-white mr-2" (click)="onOrganizerClick()" data-cy="io-toolbar-organizer-button">
      <mat-icon matTooltip="Open in new tab" matTooltipPosition="above"
      svgIcon="external-link" style="margin-top: -3px" data-cy="io-toolbar-organizer-icon"></mat-icon>
    </button>
    <button mat-mini-fab class="bg-white mr-2" (click)="onFileOpenClick()" data-cy="io-toolbar-import-button">
      <mat-icon matTooltip="Import Documents" matTooltipPosition="above"
      svgIcon="upload" style="margin-top: -3px" data-cy="io-toolbar-import-icon"></mat-icon>
    </button>
    <button mat-mini-fab class="bg-white mr-2" data-cy="io-toolbar-filter-button">
      <mat-icon matTooltip="Filter" matTooltipPosition="above" svgIcon="filter" data-cy="io-toolbar-filter-icon"></mat-icon>
    </button>
    <button mat-mini-fab class="bg-white mr-2" data-cy="io-toolbar-slideshow-button">
      <mat-icon matTooltip="Slide Show" matTooltipPosition="above" svgIcon="photo-gallery" data-cy="io-toolbar-slideshow-icon"></mat-icon>
    </button>
    <button mat-mini-fab class="bg-white mr-2" (click)="onPublishClick()" data-cy="io-toolbar-publish-button">
      <mat-icon matTooltip="Publish" matTooltipPosition="above"
      svgIcon="send-email" style="margin-top: -2px" data-cy="io-toolbar-publish-icon"></mat-icon>
    </button>
    <button mat-mini-fab class="bg-white" data-cy="io-toolbar-settings-button">
      <mat-icon matTooltip="Defaults" matTooltipPosition="above"
      svgIcon="settings" style="margin-top: -2px" data-cy="io-toolbar-settings-icon"></mat-icon>
    </button>
  </div>

  <!-- Sorting/Filtering -->
  <div class="col-8 d-flex justify-content-end" data-cy="io-toolbar-filters">
    <mat-form-field class="mr-2" data-cy="io-toolbar-size-field">
      <mat-select [value]="selectedSize" (selectionChange)="onSizeSelected($event)" data-cy="io-toolbar-size-select">
        @for (size of sizeOptions; track size) {
          <mat-option [value]="size.value" data-cy="io-toolbar-size-option">
            Size: {{size.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="mr-2" data-cy="io-toolbar-view-field">
      <mat-select [value]="enumIOViewMode.Thumbnail" (selectionChange)="onViewSelected($event)" data-cy="io-toolbar-view-select">
        @for (view of viewOptions; track view) {
          <mat-option [value]="view" data-cy="io-toolbar-view-option">
            View: {{view}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="mr-2" data-cy="io-toolbar-sort-field">
      <mat-select [value]="enumSortBy.DateCreated" (selectionChange)="onSortingSelected($event)" data-cy="io-toolbar-sort-select">
        @for (sort of sortOptions; track sort) {
          <mat-option [value]="sort" data-cy="io-toolbar-sort-option">
            Sort: {{sort}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <button mat-button class="px-1" (click)="onChangingOrder()" data-cy="io-toolbar-order-button">
      {{ options.isAscending ? 'Ascending' : 'Descending' }}
      <mat-icon data-cy="io-toolbar-order-icon">{{ options.isAscending ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
    </button>
  </div>
</div>
